<template>
    <div class="slider cloakable" :class="{'cloaked' : !slidesReady}">

        <swiper ref="mySwiper" :options="swiperOptions" @slideChangeTransitionStart="updateNavigationColor">

            <swiper-slide v-for="(slide, index) in slides" :key="index" class="slider__slide swiper-slide-active">
                <div class="slider__content">
                    <div class="slider__content__background" v-if="slide.background" :class="{'img-position' : slide.textCenter}">
                        <v-lazy-image :src="slide.background"></v-lazy-image>
                        <div class="slider__content__overlay"></div>
                    </div>

                    <div class="slider__content__background bg-position" v-if="slide.alternateImage || slide.coverImageUrl">
                        <v-lazy-image :src="slide.alternateImage ? slide.alternateImage : slide.coverImageUrl"></v-lazy-image>
                        <div class="slider__content__overlay opacity-40"></div>
                    </div>

                    <!-- <div class="slider__content__image" v-if="slide.alternateImage || slide.coverImageUrl">
                        <v-lazy-image :src="slide.alternateImage ? slide.alternateImage : slide.coverImageUrl"></v-lazy-image>
                        <div class="slider__content__overlay opacity-40"></div>
                    </div> -->

                    <div class="slider__content__display" v-if="slide.image">
                        <v-lazy-image :src="slide.image"></v-lazy-image>
                    </div>
                    <WorkoutCard :carddata="slide" class="workout-hide workout--card" v-if="slide.id"></WorkoutCard>

                    <div class="slider__content__text" :class="[{'transparent' : slide.background}, {'padded' : !slide.coverImageUrl && !slide.image}, {'mobile-centered': slide.betweenTitle}, {'absolute' :slide.id}, {'align-content' : slide.textCenter}]">
                        <div :class="{ 'running--invisible' : !slide.containsRun }" class="running running-batch running-batch--white" v-if="slide.containsRun" v-translate>includes_running</div>

                        <span class="h1" :class="{'hl': !slide.mergeTitle}">{{ slide.id ? slide.sTitle : slide.title}}</span>
                        <div class="between text text--bold" v-if="slide.betweenTitle">{{slide.betweenTitle}}</div>
                        <span class="h1 h1--normal" :class="{'hl': !slide.mergeTitle}"> {{ slide.id  ? slide.sSubtitle : slide.subtitle}}</span>

                        <div class="intro text text--bold" v-if="slide.intro" v-html="slide.intro"></div>
                        <div class="intro text text--bold" v-if="slide.sIntro" v-html="slide.sIntro"></div>

                        <span class="info text text--large" v-if="slide.id" v-html="slide.sDescription"></span>
                        <div class="info text text--large"  v-else v-html="slide.description"></div>
                        <div class="info--download" v-if="slide.appButtons && slide.downloadApp">{{slide.downloadApp}}</div>

                        <puma-button class="slider__content__button" :link="'/workout/' + slide.id" :type="'light'" v-if="slide.id"><translate>start_now</translate></puma-button>

                        <div class="slider__content__buttons" v-if="slide.appButtons">
                            <a :href="button.link" v-for="(button, index) in slide.appButtons" :key="index" :title="button.title" target="_blank" @click.prevent="downloadLinkClick(button.link, button.type)">
                                <v-lazy-image :src="button.image"></v-lazy-image>
                            </a>
                        </div>
                    </div>

                </div>
            </swiper-slide>

            <div class="swiper-pagination" slot="pagination"></div>
        </swiper>

        <div class="swiper-navigation swiper-navigation--prev">
            <Icon :name="'slider-left'"></Icon>
        </div>
        <div class="swiper-navigation swiper-navigation--next" :class="{'black' : navigationBlack}">
            <Icon :name="'slider-right'"></Icon>
        </div>

    </div>
</template>

<script>
import { captureOutboundLink } from "@/utils/tracking"
import WorkoutCard from "@/components/WorkoutCard.vue"

export default {
    name: "Slider",
    components: {
        WorkoutCard
    },
    props: {
        slides: Array,
        slidesReady: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            workouts: [],
            swiperOptions: {
                speed: 400,
                autoHeight: true,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                navigation: {
                    nextEl: '.swiper-navigation--next',
                    prevEl: '.swiper-navigation--prev'
                }
            },
            navigationBlack: false
        }
    },
    methods: {
        updateNavigationColor() {
            if(this.slides[this.$refs.mySwiper.$swiper.activeIndex].id !== undefined) {
                this.navigationBlack = true
            } else {
                this.navigationBlack = false
            }
        },
        downloadLinkClick(url, type) {
            captureOutboundLink(url, {navigation: {subSection: "home", screenName: "opportunities"}, event: {type: "download", value: `web_download_${type}`}})
        }
    }
}
</script>

<style lang="scss">
.slider {
    $block: &;
    position: relative;
    margin-bottom: 30px;

    @include mq(tablet) {
        margin-bottom: 50px;
    }

    .swiper {
        &-container {
            padding-bottom: 70px;
        }
        &-slide {
            &-active {
                .slider {
                    &__content {
                        &__text {
                            transform: translateX(0px);
                            opacity: 1;

                            @include mq(tablet) {
                                transform: translate(0px, -50%);
                            }
                        }
                    }
                }
            }
        }
        &-pagination {
            &-bullets {
                bottom: 20px;
            }
            &-bullet {
                width: 12px;
                height: 12px;
                border: solid 1px $puma-color-black;
                background: none;
                margin: 0px 8px !important;

                &-active {
                    background: $puma-color-black;
                }
            }
        }

        &-navigation {
            position: absolute;
            top: 50%;
            margin-top: -25px;
            transform: translateY(-50%);
            z-index: 20;
            color: white;
            transition: color 300ms $ease-out-quad, opacity 300ms $ease-out-quad;
            cursor: pointer;

            @include mq($until: tablet) {
                display: none;
            }

            &:focus {
                outline: none;
            }

            &.black {
                color: black;
            }

            &.swiper-button-disabled {
                opacity: 0;
                pointer-events: none;
            }

            &--prev {
                left: 50px;

                @include mq($until: notebook) {
                    left: 30px;
                }
            }

            &--next {
                right: 50px;

                @include mq($until: notebook) {
                    right: 30px;
                }
            }

            .icon {
                @include mq($until: notebook) {
                    width: 20px;
                }
            }
        }
    }

    &__content {
        width: 100%;
        position: relative;
        height: 100%;
        z-index: 10;
        display: flex;
        flex-direction: column;

        @include mq(tablet) {
            padding-bottom: 60%;
        }
        @include mq(tablet-landscape) {
            padding-bottom: 45%;
        }
        @include mq(notebook) {
            padding-bottom: 42%;
        }
        @include mq(laptop) {
            // padding-bottom: 38%;
            padding-bottom: 45%;
        }

        &__workout {
            position: absolute;
            // top: 20%;
             top: 25%;
            // left: -68px;
            left: -29px;
            right: 0;
            bottom: 0;
            width: 55.33333%;
            z-index: 5;
            display: flex;
            justify-content: center;
            padding-left: 0;

            .workout-hide {
              
                @include mq($until: tablet) {
                   display: none;
                }
            }

            @include mq($until: tablet-landscape) {
                left: 0;
            }

            @include mq($until: tablet) {
                position: relative;
                width: 100%;
                // padding: 40px 50px 0;
                height: 240px;
                top: 0;
            }

            .workout-card {
                width: 41%;
                height: 100%;
                max-height: 368px;

                &__inner {
                    width: 84.5%;
                    position: relative;
                    padding-bottom: 117%;
                    background-size: cover;
                    background-position: center center;
                    height: 0;
                    border-radius: 4px;
                    overflow: hidden;
                }
            }

            

            @include mq($until: tablet-landscape) {
                padding-left: 0;
            }

            @include mq($until: tablet) {
                position: relative;
                width: 100%;
                padding: 40px 50px 0;
                height: 240px;
            }
        }

        &__background {
            @include fillout;

            img {
                @include object-fit;
                /* New */
                object-position: center 25%;
            }

            &.bg-position {
                img {
                    @include mq($until: tablet) {
                          object-position: 31% center!important;
                    }
                }
            }

            &.img-position {
                img {
                    @include mq($until: tablet) {
                          object-position: 67% center!important;
                    }
                }
            }


            @include mq($until: tablet) {
                img {
                    object-position: 19% center;
                }
                &:after {
                    content: '';
                    display: block;
                    @include fillout;
                    height: 50%;
                    top: auto;
                    bottom: 0;
                    background: linear-gradient(to top, rgba(black, 1), rgba(black, 0) 100%);
                }
            }
        }

        &__overlay {
            position: absolute;
            top: 0;
            left: 0;
            z-index: 0;
            background-color: black;
            width: 100%;
            height: 100%;
            opacity: .5;

            &.opacity-40 {
                opacity: 0.4;
            }
        }

        &__image {
            position: relative;
            z-index: 5;
            padding-bottom: 65%;
            
            @include mq(tablet) {
                position: absolute;
                left: 0;
                top: 0;
                // width: 67%;
                width: 100%;
                padding-bottom: 0;
                height: 100%;
            }

            @include mq($until: tablet) {
                img {
                    object-position: 15% center;
                }
                &:after {
                    content: '';
                    display: block;
                    @include fillout;
                    height: 50%;
                    top: auto;
                    bottom: 0;
                    background: linear-gradient(to top, rgba(black, 1), rgba(black, 0) 100%);
                }
            }

             @include mq($until:mobile-landscape) {
                padding-bottom: 91%;
                padding-top: 23.5%;
            }

            img {
                @include object-fit;
                object-position: center top;
            }
        }

        &__display {
            @include fillout;
            width: (7 * 100% / 12);
            z-index: 5;
            display: flex;
            align-items: center;
            justify-content: center;
            padding-left: (1 * 100% / 12);

            @include mq($until: tablet-landscape) {
                padding-left: 0;
            }

            @include mq($until: tablet) {
                position: relative;
                width: 100%;
                padding: 40px 50px 0;
                height: 240px;
            }

              @include mq($until:desktop) {
                  padding-left: 1%;
                  width: 55.33333%;
              }

              @include mq($until: tablet) {
                  width: 100%;

                  img {
                      object-position: left center !important;
                      left: 6% !important;
                      transform: translate(0%, -50%) !important;
                  }
              }

            img {
                max-height: 85%;
                max-width: calc(5 * 100% / 7);

                @include mq($until: tablet) {
                    @include object-fit(contain);
                    top: 60%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                }
            }
        }

        &__text {
            position: relative;
            z-index: 15;
            padding: 30px 40px 0;
            transform: translateX(50px);
            opacity: 0;
            transition: opacity 1s ease, transform 1s ease;
            // background: white;
            color: #ffffff;
            margin-top: auto;

            &.absolute {
                 @include mq($until:tablet) {
                     top: -32px;
                     position: relative;
                     right: 0;
                    //  padding: 70px 40px 0;
                      padding: 36px 40px 0;
                 } 

                 @include mq($until: mobile-landscape) {
                        top: -30px;
                        margin-top: 16px;
                 } 

                 .text--large {
                    max-width: 455px;
                    width: 100%;
                 }
            }

            @include mq(tablet) {
                position: absolute;
                left: 52%;
                width: 45%;
                top: 50%;
                bottom: auto;
                transform: translate(50px, -50%);
                padding: 55px 50px;
            }

             @include mq(laptop) {
                left: 52%;
                width: 45%;
                left: 51%;
                width: 46%;
            }

            @include mq(desktop) {
                left: 60%;
                width: 40%;
            }

             @include mq(notebook) {
                left: 60%;
                width: 37%;
            }

            &.transparent {
                background: transparent;
                padding-bottom: 30px;
                
                & > * {
                    color: white !important;
                }
            }

            &.padded {
                @include mq($until: tablet) {
                    margin-top: 230px;

                    & > * {
                        position: relative;
                        z-index: 1;
                    }
                }
            }

            &.mobile-centered {
                @include mq($until: tablet) {
                    text-align: center;

                    & > * {
                        margin-left: auto;
                        margin-right: auto;
                    }

                    #{$block}__content__buttons {
                        justify-content: center;

                        & > * {
                            &:last-child {
                                margin: 0 5px 10px;
                            }
                        }
                    }
                }
            }

            .hl {
                display: block;
            }

            .between {
                @include mq(tablet) {
                    padding-left: 40%;
                }
            }

            .intro {
                text-transform: uppercase;
                margin-top: 12px;
                margin-bottom: 12px;

                @include mq($until: tablet) {
                    margin-top: 0;
                    margin-bottom: 20px;
                }
            }

            .info {
                display: block;
                margin-top: 5px;
                // max-width: 340px;


                @include mq($until: tablet) {
                    font-size: $puma-size-font-sm;
                }
                @include mq(tablet) {
                    margin-top: 12px;
                }

                .capitalize {
                    text-transform: capitalize;
                }

                &--download {
                    font-size: $puma-size-font-sm;
                    font-weight: bold;
                    line-height: 2.43;
                    letter-spacing: 0.4px;
                    color: #eaeae5;
                    text-transform: uppercase;
                    margin-top: 24px;
                }
            }
            .running {
                margin-bottom: 20px;

                &--invisible {
                    opacity: 0;
                }
            }
            
        }

        &__button {
            margin-top: 15px;

            @include mq(tablet) {
                margin-top: 40px;
            }
        }

        &__buttons {
            display: flex;
            flex-wrap: wrap;
            margin-top: 12px;
            min-height: 40px;

            & > * {
                display: block;
                margin-right: 14px;
                margin-bottom: 12px;
                line-height: 1;

                img {
                    height: 40px;
                    width: auto;
                }
            }

            &.center {
                justify-content: center;
            }
        }
    }
}

.workout--card {
    position: absolute;
    top: 20%;
    left: 10%;
    margin: 0 auto;
    z-index: 15;
    width: 24.45%;

    @include mq($until:tablet) {
        left: -1.5%;
        width: 37.45%;
        position: relative;
        margin: 0 40px;
    }

    @include mq($until:mobile-landscape) {
        width: 66.45%;
        top: 15px;
    }
}

.align-content {
  
    @include mq(tablet) {
        position: absolute;
        // left: 52%;
        // width: 47%;
        left: 0;
        width: 100%;
        top: 50%;
        bottom: auto;
        transform: translate(50px, -50%);
        padding: 55px 50px;
    }

    @include mq($until:desktop) {
        // left: 60%;
        // width: 35%;

        left: 45%;
        width: 55%;
    }

        @include mq(laptop) {
        // left: 52%;
        // width: 45%;
        left: 51%;
        width: 46%;
    }


    @include mq(desktop) {
        // left: 60%;
        // width: 35%;

        left: 56%;
        width: 53%;
    }


        @include mq(notebook) {
        // left: 60%;
        // width: 35%;

        left: 60%;
        width: 48%;
    }

    @media only screen and (max-width: 760px) {
        left: 0 !important;
        width: 100%;
    }
}
</style>